import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule, MissingTranslationHandler, TranslateService } from '@ngx-translate/core';

import { TranslateHttpLoaderFactory } from './translate-http-loader.factory';
import { AppMissingTranslationHandler } from './missing-translation.handler';
import { bootstrapInternalizationModule } from './i18n.bootstrap';
import { InternalizationService } from './i18n.service';

@NgModule({
  imports: [
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateHttpLoaderFactory,
        deps: [HttpClient]
      },
      useDefaultLang: false,
      missingTranslationHandler: {provide: MissingTranslationHandler, useClass: AppMissingTranslationHandler}
    })
  ],
  exports: [TranslateModule],
  providers: [
    InternalizationService,
    {
      provide: APP_INITIALIZER,
      useFactory: bootstrapInternalizationModule,
      deps: [InternalizationService],
      multi: true
    }
  ]
})



export class InternalizationModule {

}



// WEBPACK FOOTER //
// ./src/config/i18n/i18n.module.ts